import Formulario from './formulario';

export const FormularioPeriodos = (props: any) => {
	let { handle, data, selected, ejercicio, onClose } = props;

	return <Formulario onSave={handle} data={data} selected={selected} ejercicio={ejercicio} onClose={onClose}/>
}

export default FormularioPeriodos;